export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_bin-rental-to/artifacts/tgcs1t6n_MINI%20BINS%20LOGO.png";

export const HERO_IMAGE =
  "https://customer-assets.emergentagent.com/job_bin-rental-to/artifacts/8dqpbt6s_4522904d-e979-40a0-a8da-997ad71d48b7_Original.jpg";

export const SKYLINE_IMAGE =
  "https://images.unsplash.com/photo-1517935706615-2717063c2225?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHwxfHx0b3JvbnRvJTIwc2t5bGluZXxlbnwwfHx8fDE3ODEwMTg4MTN8MA&ixlib=rb-4.1.0&q=85";

export const RUBBLE_IMAGE =
  "https://customer-assets.emergentagent.com/job_bin-rental-to/artifacts/tsk0fvc5_86624.jpg";

export const FLEET_IMAGES = [
  "https://customer-assets.emergentagent.com/job_bin-rental-to/artifacts/5g6bm03q_IMG_0649_Original.JPG",
  "https://customer-assets.emergentagent.com/job_bin-rental-to/artifacts/x7vm4b1w_c051ea31-5605-48b0-8a63-69a23c6ca002_Original.jpg",
  "https://customer-assets.emergentagent.com/job_bin-rental-to/artifacts/75yn1vb6_52eeea3b-f174-4cbe-9531-53248728f305_Original.jpg",
];

export const COMPANY = {
  name: "Troya Mini Bins Inc.",
  short: "Troya Mini Bins",
  tagline: "Quality You Can Trust",
  phone: "(289) 401-0770",
  phoneRaw: "+12894010770",
  email: "troyaminibins@gmail.com",
  hours: "Mon–Sat 7:00 AM – 7:00 PM · Sun 8:00 AM – 5:00 PM",
  area: "Toronto & the Greater Toronto Area",
};

export const SERVICE_TYPES = [
  "Mixed Waste",
  "Shingles",
  "Concrete",
  "Soil / Dirt",
  "Brick",
  "Metal",
  "Not sure — recommend for me",
];

export const BIN_SIZES = [
  '6 yd³',
  '10 yd³',
  '14 yd³',
  '16 yd³',
  '20 yd³',
];

export const PRICING = {
  "Mixed Waste": [
    { size: "6 yd³",  tiers: [{ tons: 1, price: 370 }] },
    { size: "10 yd³", tiers: [{ tons: 1, price: 370 }] },
    { size: "14 yd³", tiers: [{ tons: 2, price: 470 }] },
    { size: "16 yd³", tiers: [{ tons: 2.5, price: 520 }] },
    { size: "20 yd³", tiers: [{ tons: 3, price: 599 }, { tons: 4, price: 679 }] },
  ],
  "Shingles": [
    { size: "6 yd³",  tiers: [{ tons: 1, price: 360 }] },
    { size: "10 yd³", tiers: [{ tons: 2, price: 470 }] },
    { size: "14 yd³", tiers: [{ tons: 2, price: 470 }] },
    { size: "16 yd³", tiers: [{ tons: 2.5, price: 520 }] },
  ],
  "Concrete": [
    { size: "6 yd³", tiers: [{ tons: 2, price: 349 }] },
  ],
  "Soil / Dirt": [
    { size: "6 yd³", tiers: [{ tons: 1, price: 349 }] },
  ],
  "Brick": [
    { size: "6 yd³", tiers: [{ tons: 2, price: 399 }] },
  ],
  "Metal": [
    { size: "6 yd³",  tiers: [{ tons: 1, price: 299 }] },
    { size: "10 yd³", tiers: [{ tons: 2, price: 399 }] },
    { size: "14 yd³", tiers: [{ tons: 3, price: 499 }] },
    { size: "16 yd³", tiers: [{ tons: 4, price: 599 }] },
    { size: "20 yd³", tiers: [{ tons: 5, price: 699 }] },
  ],
};

export const SIZE_GUIDE = [
  { size: "6 yd³",  best: "1 bathroom reno, single-material loads (soil, concrete, brick, metal), 30 shingle bundles or less", icon: "small" },
  { size: "10 yd³", best: "Small kitchen or 1 room reno, garage cleanout, 30–90 shingle bundles", icon: "medium-small" },
  { size: "14 yd³", best: "2 rooms / 1 regular or large kitchen reno, 90–120 shingle bundles", icon: "medium" },
  { size: "16 yd³", best: "3 rooms / 2 rooms + 1 bath / 1 room + 1 kitchen + 1 bath, 120–160 shingle bundles", icon: "large" },
  { size: "20 yd³", best: "Full level (main or basement) reno, large mixed waste, construction debris", icon: "xlarge" },
];

export const AUDIENCES = [
  "Construction / Renovation Debris",
  "Restoration Jobs",
  "Roofing Projects",
  "Apartment Complexes",
  "Property Managers",
  "Non-Profit Organizations",
  "Commercial",
  "Homeowners",
];
